var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main-header" } }, [
    _c(
      "nav",
      { staticClass: "navbar navbar-default no-margin app-sidebar-nav" },
      [
        _c("header", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "logo-section col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"
            },
            [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.dashboardPageRedirect()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/static/images/vvg-logo.png",
                      alt: "VVG Logo"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "search-section col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
            },
            [
              _c("div", { staticClass: "form-group has-search" }, [
                _c(
                  "form",
                  {
                    attrs: { action: "", autocomplete: "on" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.universalSearchAPI()
                      }
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.universalSearchText,
                          expression: "universalSearchText"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "customerGlobalSearch",
                        type: "text",
                        placeholder: "Search Part : (Sample ATR TR46-41002)"
                      },
                      domProps: { value: _vm.universalSearchText },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.universalSearchText = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "fa fa-search form-control-feedback"
                    })
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "action-btn-section col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
            },
            [
              _vm.isUserLogin
                ? [
                    _c("v-select", {
                      staticStyle: { width: "265px" },
                      attrs: {
                        name: "customerId",
                        id: "customerId",
                        label: "text",
                        filterable: true,
                        options: _vm.customerArr,
                        clearable: false,
                        placeholder: "Select Customer"
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChnageCustomer()
                        }
                      },
                      model: {
                        value: _vm.customerId,
                        callback: function($$v) {
                          _vm.customerId = $$v
                        },
                        expression: "customerId"
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("label", { staticClass: "dropdown" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  staticClass: "dd-input",
                  attrs: { type: "checkbox", id: "test" }
                }),
                _vm._v(" "),
                _c("ul", { staticClass: "dd-menu" }, [
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.logout()
                          }
                        }
                      },
                      [_vm._v("Logout")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "orders-btn" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goToOrderListWithFilters()
                      }
                    }
                  },
                  [_vm._m(1), _vm._v(" order\n                    ")]
                )
              ]),
              _vm._v(" "),
              !_vm.isUserLogin
                ? [
                    _c("div", { staticClass: "shopping-cart-img" }, [
                      _c(
                        "a",
                        {
                          staticClass: "cart-img",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.useParts()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "/static/images/cart-img.png",
                              alt: "Shopping Cart"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "shopping-cart-img" }, [
                      _c(
                        "a",
                        {
                          staticClass: "cart-img",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.notificationClick()
                            }
                          }
                        },
                        [
                          _vm.isNotificationEnable
                            ? [
                                _c("img", {
                                  attrs: {
                                    src: "/static/images/d_notification.png",
                                    alt: "Disable Notification Bell",
                                    title: "Disable Notification"
                                  }
                                })
                              ]
                            : [
                                _c("img", {
                                  attrs: {
                                    src: "/static/images/e_notification.png",
                                    alt: "Enable Notification Bell",
                                    title: "Enable Notification"
                                  }
                                })
                              ]
                        ],
                        2
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm._m(2)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dd-button" }, [
      _c("span", [
        _c("img", {
          attrs: { src: "/static/images/avtar-img.png", alt: "User Account" }
        })
      ]),
      _vm._v(" My Account\n                    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: { src: "/static/images/order-img.png", alt: "Order" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { display: "none" },
        attrs: {
          href: "javascript:void(0)",
          id: "scroll",
          title: "Scroll to Top"
        }
      },
      [_vm._v("Top"), _c("span")]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1f23230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1f23230","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/CustomerHeader.vue
// module id = null
// module chunks = 